/* eslint-disable no-plusplus */
/* eslint-disable max-len */
import '../../assets/css/base/gnb-footer.css';
import '../../assets/css/pages/popup-main.css';
import '../../assets/css/pages/validation.css';
import '../../assets/css/pages/main.css';
import { setCookie, getCookie } from '../utils/common';
import { LOAD_BASE_URL } from '../../config';

const modal = document.querySelector('.modalWrap');
const modalBody = document.getElementById('modalBody');
const closeBtn = document.getElementById('close_btn');
const todayBtn = document.getElementById('today_close_btn');
const mainHof = document.getElementById('main_hof');
let jsonData = '';

function jsonRequest(url, callback) {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.onload = function () {
    if (xhr.status === 200) {
      callback(JSON.parse(xhr.responseText));
    } else {
      console.error(`Failed to load JSON file: ${xhr.statusText}`);
    }
  };
  xhr.send();
}

document.addEventListener('DOMContentLoaded', () => {
  const images = document.querySelectorAll('.video-section .left-wrap .img-slide img');

  let currentIndex = 0;

  setInterval(() => {
    images[currentIndex].classList.remove('active');

    currentIndex = (currentIndex + 1) % images.length;

    images[currentIndex].classList.add('active');
  }, 3000);

  const wrapperEle = document.querySelector('#wrapper');
  const mainVisual = document.querySelector('.main_visual');

  if (mainVisual && wrapperEle) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            wrapperEle.classList.remove('on');
          } else {
            wrapperEle.classList.add('on');
          }
        });
      },
      {
        root: null,
        threshold: 0.1, // 10% 이상 보이면 isIntersecting = true
      },
    );

    observer.observe(mainVisual);
  }

  jsonRequest(`${LOAD_BASE_URL}/json/chuncheon-popup.json`, (data) => {
    jsonData = data;

    const modalImg = document.getElementById('modal_img');

    if (getCookie('ch_notToday') === 'Y') {
      modal.style.display = 'none';
    } else if (jsonData && new Date(jsonData.endDate).getTime() > new Date().getTime()
      && new Date(jsonData.startDate).getTime() < new Date().getTime() && jsonData.pcImage && jsonData.pcImage !== '') {
      modal.style.display = 'block';
      modalBody.style.maxWidth = `${jsonData.width}px`;

      let jsonTarget;
      let jsonUrl;

      if (jsonData.url === '') {
        jsonTarget = '';
        // eslint-disable-next-line no-script-url
        jsonUrl = 'javascript:void(0);';
      } else {
        jsonTarget = '_blank';
        jsonUrl = jsonData.url;
      }

      modalImg.innerHTML = `
            <a target='${jsonTarget}' href='${jsonUrl}'>
              <img src='${LOAD_BASE_URL}/popup/${jsonData.pcImage}' class='desktop' style='max-height: 640px'>
              <img src='${LOAD_BASE_URL}/popup/${jsonData.mobileImage}' class='mobile'>
            </a>
          `;
    } else {
      modal.style.display = 'none';
    }
  });

  jsonRequest(`${LOAD_BASE_URL}/json/chuncheon-hof.json`, (data) => {
    mainHof.innerHTML = '';

    for (let i = 0; i < 2; i++) {
      data.forEach((item) => {
        mainHof.innerHTML += `
              <div class='item'>
                <div class='thumb'>
                    <div class='bg_mask'>
                      <div class='text_wrap'>
                        <div class='name'>${item.name}</div>
                        <dl>
                        <dt>완주횟수</dt>
                        <dd>${item.recordCnt}회</dd>
                        </dl>
                        <dl>
                        <dt>참가연도</dt>
                        <dd>${item.minYear}~${item.maxYear}</dd>
                        </dl>
                        <dl>
                        <dt>최고기록</dt>
                        <dd>${item.bestRecord}(${item.bestYear})</dd>
                        </dl>
                      </div>
                    </div>
                    <img src='${LOAD_BASE_URL}/hof/${item.image}'alt=''>
                </div>
              </div>
            `;
      });
    }
  });
});

todayBtn.addEventListener('click', () => {
  setCookie('ch_notToday', 'Y', 1);
  modal.style.display = 'none';
  document.body.style.position = 'initial';
});

closeBtn.addEventListener('click', () => {
  modal.style.display = 'none';
  document.body.style.position = 'initial';
});
